import * as actionTypes from '../../action/company/Company'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: ''
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_GETCOMPANY_FETCH:
            return {
                ...state,
                isFetching: true
            };
        case actionTypes.GET_GETCOMPANY_SUCCESS :
            return {
                ...state,
                isFetching: false,
                error: false,
                company: action.payload
            };
        
        case actionTypes.GET_GETCOMPANY_FAILURE :
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_GETCOMPANY_MESSAGE:
            return {
                ...state,
                isFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;